/**
 * quote-cart.js  v2
 * Mediterranean Pool Tiles — Quote Request Cart
 *
 * Uses event delegation on document.body so the click handler
 * works regardless of whether this script loads before or after
 * the product page buttons are rendered.
 *
 * Product data is read from data-qc-product JSON attribute —
 * no inline onclick, no timing race conditions.
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'mpt_quote_cart';

  /* ─────────────────────────────────────
     STORAGE
  ───────────────────────────────────── */
  function getCart() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveCart(cart) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cart)); }
    catch (e) {}
  }
  function clearCart() {
    try { localStorage.removeItem(STORAGE_KEY); }
    catch (e) {}
  }

  /* ─────────────────────────────────────
     CART OPERATIONS
  ───────────────────────────────────── */
  function addItem(item) {
    var cart = getCart();
    var exists = cart.some(function (c) { return String(c.id) === String(item.id); });
    if (!exists) {
      cart.push({
        id:       String(item.id),
        title:    item.title    || '',
        type:     item.type     || '',
        image:    item.image    || '',
        url:      item.url      || '',
        material: item.material || '',
        size:     item.size     || '',
        origin:   item.origin   || 'Morocco',
        sqft:     parseInt(item.sqft, 10) || 50
      });
      saveCart(cart);
    }
    renderCart();
    openDrawer();
    updateAllAddButtons();
  }

  function removeItem(id) {
    saveCart(getCart().filter(function (c) { return String(c.id) !== String(id); }));
    renderCart();
    updateAllAddButtons();
  }

  function updateSqft(id, val) {
    var cart = getCart();
    var item = cart.find(function (c) { return String(c.id) === String(id); });
    if (item) { item.sqft = parseInt(val, 10) || 50; saveCart(cart); }
  }

  function isInCart(id) {
    return getCart().some(function (c) { return String(c.id) === String(id); });
  }

  /* ─────────────────────────────────────
     RENDER
  ───────────────────────────────────── */
  function renderCart() {
    var cart        = getCart();
    var list        = document.getElementById('qc-items-list');
    var emptyEl     = document.getElementById('qc-empty');
    var itemsCta    = document.getElementById('qc-items-cta');
    var trigger     = document.getElementById('qc-trigger');
    var tabCount    = document.getElementById('qc-tab-count');
    var triggerCount = document.getElementById('qc-trigger-count');

    if (!list) return;

    var count = cart.length;
    if (triggerCount) triggerCount.textContent = count;
    if (tabCount)     tabCount.textContent = count > 0 ? '(' + count + ')' : '';
    if (trigger)      trigger.style.display = count > 0 ? 'flex' : 'none';

    if (count === 0) {
      list.innerHTML = '';
      if (emptyEl)  emptyEl.style.display  = 'block';
      if (itemsCta) itemsCta.style.display = 'none';
    } else {
      if (emptyEl)  emptyEl.style.display  = 'none';
      if (itemsCta) itemsCta.style.display = 'block';

      list.innerHTML = cart.map(function (item) {
        return [
          '<div class="qc-item" data-id="' + esc(item.id) + '">',
            item.image
              ? '<img class="qc-item__img" src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy">'
              : '<div class="qc-item__img"></div>',
            '<div class="qc-item__info">',
              item.type ? '<span class="qc-item__type">' + esc(item.type) + '</span>' : '',
              '<a class="qc-item__name" href="' + esc(item.url) + '" target="_blank">' + esc(item.title) + '</a>',
              '<div class="qc-item__qty-row">',
                '<span class="qc-item__qty-label">Sq ft</span>',
                '<input class="qc-item__qty" type="number" min="50" step="10"',
                  ' value="' + item.sqft + '"',
                  ' data-id="' + esc(item.id) + '"',
                  ' aria-label="Square footage for ' + esc(item.title) + '">',
                '<span class="qc-item__qty-unit">sq ft</span>',
              '</div>',
            '</div>',
            '<button class="qc-item__remove" data-remove="' + esc(item.id) + '"',
              ' aria-label="Remove ' + esc(item.title) + '">&#215;</button>',
          '</div>'
        ].join('');
      }).join('');

      // Qty listeners
      list.querySelectorAll('.qc-item__qty').forEach(function (input) {
        input.addEventListener('change', function () {
          updateSqft(input.dataset.id, input.value);
        });
      });
      // Remove listeners
      list.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeItem(btn.dataset.remove);
        });
      });
    }
    updateFooter();
  }

  /* ─────────────────────────────────────
     DRAWER
  ───────────────────────────────────── */
  var drawerOpen = false;

  function openDrawer() {
    var drawer  = document.getElementById('qc-drawer');
    var overlay = document.getElementById('qc-overlay');
    var trigger = document.getElementById('qc-trigger');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawerOpen = true;
    setTimeout(function () {
      var close = document.getElementById('qc-close');
      if (close) close.focus();
    }, 120);
  }

  function closeDrawer() {
    var drawer  = document.getElementById('qc-drawer');
    var overlay = document.getElementById('qc-overlay');
    var trigger = document.getElementById('qc-trigger');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
    document.body.style.overflow = '';
    drawerOpen = false;
  }

  /* ─────────────────────────────────────
     TABS
  ───────────────────────────────────── */
  function switchTab(tab) {
    document.querySelectorAll('.qc-tab').forEach(function (t) {
      var active = t.dataset.tab === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    document.querySelectorAll('.qc-tab-panel').forEach(function (p) {
      p.classList.remove('is-active');
    });
    var panel = document.getElementById('qc-panel-' + tab);
    if (panel) panel.classList.add('is-active');
    updateFooter();
  }

  function updateFooter() {
    var submitBtn = document.getElementById('qc-submit-btn');
    if (!submitBtn) return;
    var formPanel = document.getElementById('qc-panel-form');
    submitBtn.style.display = (formPanel && formPanel.classList.contains('is-active')) ? 'flex' : 'none';
  }

  /* ─────────────────────────────────────
     UPDATE ALL ADD BUTTONS ON PAGE
  ───────────────────────────────────── */
  function updateAllAddButtons() {
    document.querySelectorAll('[data-qc-add]').forEach(function (btn) {
      if (isInCart(btn.dataset.qcAdd)) {
        btn.classList.add('is-added');
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 8l4 4 6-6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg> Added to Quote';
      } else {
        btn.classList.remove('is-added');
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg> Add to Quote';
      }
    });
  }

  /* ─────────────────────────────────────
     FORM
  ───────────────────────────────────── */
  function buildEmailBody() {
    var cart = getCart();
    var lines = [
      '=== QUOTE REQUEST — MEDITERRANEAN POOL TILES ===',
      '',
      'TILES REQUESTED (' + cart.length + ' product' + (cart.length !== 1 ? 's' : '') + ')',
      '─────────────────────────────────────────────────'
    ];
    cart.forEach(function (item, i) {
      lines.push(
        (i + 1) + '. ' + item.title,
        '   Type:     ' + (item.type     || '—'),
        '   Material: ' + (item.material || '—'),
        '   Size:     ' + (item.size     || '—'),
        '   Origin:   ' + (item.origin   || 'Morocco'),
        '   Sq Ft:    ' + item.sqft + ' sq ft',
        '   Image:    ' + item.image,
        '   URL:      ' + item.url,
        ''
      );
    });
    lines.push(
      'CONTACT INFORMATION',
      '─────────────────────────────────────────────────',
      'Name:    ' + v('qcf-fn') + ' ' + v('qcf-ln'),
      'Email:   ' + v('qcf-email'),
      'Phone:   ' + (v('qcf-phone') || 'Not provided'),
      'Role:    ' + (v('qcf-role')  || '—'),
      'Company: ' + (v('qcf-company') || 'Not provided'),
      '',
      'PROJECT DETAILS',
      '─────────────────────────────────────────────────',
      'Project Type:   ' + (v('qcf-type')     || '—'),
      'Square Footage: ' + (v('qcf-sqft')     || '—'),
      'Timeline:       ' + (v('qcf-timeline') || '—'),
      'State/Region:   ' + (v('qcf-state')    || '—'),
      'Budget:         ' + (v('qcf-budget')   || '—'),
      '',
      'PROJECT NOTES',
      '─────────────────────────────────────────────────',
      v('qcf-notes') || '(none)',
      '',
      '=== END OF QUOTE REQUEST ==='
    );
    return lines.join('\n');
  }

  function v(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function validateForm() {
    var valid = true;
    var form  = document.getElementById('qc-form');
    if (!form) return false;
    form.querySelectorAll('.qc-field').forEach(function (f) { f.classList.remove('qc-field--error'); });
    form.querySelectorAll('[required]').forEach(function (el) {
      var field = el.closest('.qc-field');
      if (!field) return;
      if (el.type === 'checkbox') {
        if (!el.checked) { field.classList.add('qc-field--error'); valid = false; }
        return;
      }
      if (el.type === 'email') {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) {
          field.classList.add('qc-field--error'); valid = false;
        }
        return;
      }
      if (!el.value.trim()) { field.classList.add('qc-field--error'); valid = false; }
    });
    return valid;
  }

  function submitForm() {
    if (!validateForm()) {
      var first = document.querySelector('#qc-form .qc-field--error');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var bodyField = document.getElementById('qc-body-field');
    if (bodyField) bodyField.value = buildEmailBody();

    var btn = document.getElementById('qc-submit-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

    var form = document.getElementById('qc-form');
    if (!form) return;

    fetch('/contact', {
      method: 'POST',
      body:   new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
    .then(function () { showSuccess(); })
    .catch(function () { showSuccess(); });
  }

  function showSuccess() {
    var form    = document.getElementById('qc-form');
    var success = document.getElementById('qc-success');
    var btn     = document.getElementById('qc-submit-btn');
    if (form)    form.style.display    = 'none';
    if (success) success.style.display = 'block';
    if (btn)     btn.style.display     = 'none';
    clearCart();
    renderCart();
    updateAllAddButtons();
  }

  /* ─────────────────────────────────────
     ESCAPE
  ───────────────────────────────────── */
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ─────────────────────────────────────
     INIT — event delegation approach
     Listens on document so it works even if
     script loads before buttons are painted.
  ───────────────────────────────────── */
  function init() {
    renderCart();

    /* ── EVENT DELEGATION on document ──
       Catches clicks on [data-qc-add] buttons no matter when they render */
    document.addEventListener('click', function (e) {

      /* Add to Quote button */
      var addBtn = e.target.closest('[data-qc-add]');
      if (addBtn && addBtn.dataset.qcProduct) {
        e.preventDefault();
        try {
          var item = JSON.parse(addBtn.dataset.qcProduct);
          addItem(item);
        } catch (err) {
          console.warn('QuoteCart: could not parse product data', err);
        }
        return;
      }

      /* Trigger floating button */
      if (e.target.closest('#qc-trigger')) { openDrawer(); return; }

      /* Close button */
      if (e.target.closest('#qc-close'))   { closeDrawer(); return; }

      /* Overlay */
      if (e.target.id === 'qc-overlay')    { closeDrawer(); return; }

      /* Tab buttons */
      var tab = e.target.closest('.qc-tab');
      if (tab && tab.dataset.tab)           { switchTab(tab.dataset.tab); return; }

      /* Continue to form */
      if (e.target.closest('#qc-go-to-form')) { switchTab('form'); return; }

      /* Submit */
      if (e.target.closest('#qc-submit-btn')) { submitForm(); return; }
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeDrawer();
    });

    /* Live validation clear */
    document.addEventListener('input', function (e) {
      var field = e.target.closest('#qc-form .qc-field');
      if (field) field.classList.remove('qc-field--error');
    });
    document.addEventListener('change', function (e) {
      var field = e.target.closest('#qc-form .qc-field');
      if (field) field.classList.remove('qc-field--error');
    });

    /* Expose API globally */
    window.QuoteCart = { addItem: addItem, isInCart: isInCart, open: openDrawer };
  }

  /* Run as soon as possible */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
